export function errorMessageMetrics(code: string): string {
  switch (code) {
    case "INVALID_NUMBER":
      return "Invalid Number";
    case "INVALID_CONTACT":
      return "Invalid Contact";
    case "INVALIDS":
      return "Invalids";
    case "OPT_OUT":
      return "Opt Out";
    case "SUCCESS":
      return "Success";
    case "SENT":
      return "Sent";
    case "TOTAL_CLICKS":
      return "Total Clicks";
    case "UNSUBSCRIBED_TOTAL":
      return "Unsubscribed Count";
    case "UNSUBSCRIBED_RATE":
      return "Unsubscribed Rate";
    case "CLICKS_RATE":
      return "Click Rate";
    case "INVALID_TEXT_MESSAGE":
      return "Invalid Text Length";
    case "IGNORE":
      return "ignore";
    case "PENDING_STATUS":
      return "Pending Status";
    default:
      return "Unknown Error Occurred";
  }
}

export interface ISparkPostMetrics {
  count_targeted: number;
  count_injected: number;
  count_sent: number;
  count_accepted: number;
  count_delivered: number;
  count_delivered_first: number;
  count_delivered_subsequent: number;
  count_rendered: number;
  count_initial_rendered: number;
  count_unique_rendered: number;
  count_unique_initial_rendered: number;
  count_unique_confirmed_opened: number;
  count_clicked: number;
  count_unique_clicked: number;
  count_bounce: number;
  count_hard_bounce: number;
  count_soft_bounce: number;
  count_block_bounce: number;
  count_admin_bounce: number;
  count_undetermined_bounce: number;
  count_rejected: number;
  count_policy_rejection: number;
  count_generation_failed: number;
  count_generation_rejection: number;
  count_inband_bounce: number;
  count_outofband_bounce: number;
  count_delayed: number;
  count_delayed_first: number;
  total_msg_volume: number;
  count_spam_complaint: number;
  total_delivery_time_first: number;
  total_delivery_time_subsequent: number;
  count_unsubscribe: number;
}

export interface IAudienceMetrics {
  missing: number;
  deactivated: number;
  bothOff: number;
  unsubscribed: number;
  noContact: number;
  noReachable: number;
  duplicated: number;
  sms: number;
  email: number;
}
